<div>
    <iui-messages #messages  class="ms-auto me-auto"></iui-messages>
</div>
<div class="d-flex justify-content-end">
    <button i18n class="btn btn-primary me-3" (click)="next()" id="topnextBtn">
        Next
    </button>
    <div *ngIf="!renew && !bulk">
        <button i18n class="btn btn-secondary" (click)="cancelOrder()" id="topcanOrder">
            {{ isPayLater() ? "Cancel" : "Clear Order" }}
        </button>
    </div>
    <div *ngIf="renew || bulk">
        <button i18n class="btn btn-secondary" (click)="cancelOrder()" id="topcanOrder">
            Cancel Renew
        </button>
    </div>
</div>
<h3 i18n> Cart Details </h3>
<div *ngIf="!renew && !bulk" class="mt-2">
    <p><small i18n>The Registry must receive payment before a short code is leased to the CSC Registrant.</small></p>
</div>
<div *ngIf="(renew || bulk) && !pendingOrder.monthlyBillingEligible" class="mt-2">
    <p><small i18n>The Registry must receive payment before a short code lease is renewed. </small></p>
</div>
<div *ngIf="renew && pendingOrder.monthlyBillingEligible && !bulk" class="mt-2">
    <p><small i18n id="renewMonEligible">The Registry must receive payment before a short code lease is renewed.
        </small>
        <small i18n>To renew a lease into monthly billing, update the term to Billed Monthly</small>
    </p>
</div>

<div class="col-12">
    <p-table styleClass="p-datatable-striped" [columns]="tableColumn" [value]="pendingOrder.leases">
        <ng-template pTemplate="header" let-columns>
            <tr *ngIf="pendingOrder.leases.length > 0">
                <th [style.width.%]="col.width" *ngFor="let col of columns" class="noBorder" [ngClass]="col.field"
                    [id]="col.field">
                    {{col.header}}
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr>
                <td *ngFor="let col of columns" class="noBorder" [ngSwitch]="col.field" [ngClass]="col.field"
                    [id]="col.field+rowData.scId">
                    <div *ngIf="!renew">
                        <div *ngSwitchCase="'include'">
                            <p-checkbox [disabled]="isPayLater()" [(ngModel)]="rowData.selected" [binary]="true"
                                (onChange)="calculateCodePrice()" id="checkbox{{rowData.scId}}">
                            </p-checkbox>
                        </div>
                    </div>
                    <div *ngSwitchDefault>{{ rowData[col.field] }}</div>
                    <div *ngSwitchCase="'term'">
                        <div
                            *ngIf="!(rowData.term === 1 && ( pendingOrder.choseBilledMonthly || ifRenew1Plus12DeadlinePassed()) )">
                            <p-dropdown appDd [disabled]="isPayLater() || rowData.selected === false" [options]="termOptions" [(ngModel)]="rowData.term" appendTo="body" 
                                [filter]="true" (onChange)="calculateCodePrice(rowData)" id="dropdown{{rowData.scId}}" appTid>
                            </p-dropdown>
                        </div>

                        <div
                            *ngIf="rowData.term === 1 && ( pendingOrder.choseBilledMonthly || ifRenew1Plus12DeadlinePassed())">
                            1-Month
                        </div>
                    </div>
                    <div *ngSwitchCase="'scId'">
                        {{ rowData[col.field] }} <span *ngIf="rowData.ANString">({{rowData?.ANString}})</span>
                    </div>
                    <div *ngSwitchCase="'price'">
                        {{ rowData[col.field] | currency }}
                    </div>
                    <div *ngSwitchCase="'shortCodeType'">
                        {{ rowData.selectType }}
                    </div>
                    <div *ngSwitchCase="'discount'">
                        <span *ngIf="rowData.discountAmount || getDiscountList(rowData).length >0">
                            {{ getDiscountList(rowData) }} <span *ngIf="rowData.discountAmount">({{
                                rowData.discountAmount | currency }}) </span>
                        </span>
                    </div>
                    <div *ngSwitchCase="'listPrice'">
                        {{ rowData.listPrice | currency }}
                    </div>
                    <div *ngIf="!renew">
                        <div *ngSwitchCase="'delete'" class="d-flex align-items-center justify-content-center">
                            <a *ngIf="!isPayLater()" class="ms-2" style="cursor: pointer;"
                                (click)="removeFromCart(rowData.scId)" id="remove{{rowData.scId}}"><i
                                    class="far fa-trash-can fa-xl icon-teal"></i></a>
                            <a *ngIf="isPayLater()" class="diabled ms-2" style="cursor: pointer;"
                                id="remove{{rowData.scId}}"><i class="far fa-trash-can fa-xl icon-disabled"></i></a>
                        </div>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template *ngIf="!renew && !bulk" pTemplate="emptymessage" let-columns>
            <tr>
                <td [attr.colspan]="columns.length" class="noBorder" style="background-color: #EEF7F7;">
                    <p><small i18n>You don't have any codes in your cart yet. <br> Use the Add Codes section below to
                            add codes to your cart.</small></p>
                </td>
            </tr>
        </ng-template>
        <ng-template *ngIf="renew || bulk" pTemplate="emptymessage" let-columns>
            <tr>
                <td [attr.colspan]="columns.length" class="noBorder" style="background-color: #EEF7F7;">
                    <p><small i18n>Since there are no codes in the cart, please cancel this renew and start over.</small></p>
                </td>
            </tr>
        </ng-template>
    </p-table>
    <div *ngIf="pendingOrder.leases.length > 0" class="mt-3">
        <div *ngIf="!isRenew1Plus12()">
            <h5><b>Total: {{ pendingOrder.totalPrice | currency }}</b></h5>
        </div>
          <div *ngIf="isRenew1Plus12() && pendingOrder.leases.length > 1">
            <h5><b>Total: {{ pendingOrder.totalPrice | currency }} ({{ pendingOrder.leases[0].price | currency}} to be
                    paid in monthly installments of {{ (pendingOrder.leases[0].price || 0)/12 | currency}}.)</b></h5>
            <span *ngIf="getDiscountList(pendingOrder.leases[0]).length >0">
                <h6>The Billed Monthly calculated price may vary depending on the validity of the applied discount and
                    will be determined when payment is made on the 1-Month lease.</h6>
            </span>
            <h5><b>Due Now: {{pendingOrder.leases[1].price | currency}} (Must be paid by {{
                    pendingOrder.renewalDeadLineStr}} for the lease to automatically roll over into Monthly
                    Billing.)</b></h5>
        </div>
    </div>
    <div *ngIf="cartTabMessage" class="mt-3">
        <span id="cartTabMessage" class="error-text">{{cartTabMessage}}</span>
    </div>
    <div *ngIf="!renew && !bulk && monthlyBilling && pendingOrder.leases.length > 0" class="mt-4">
        <p><small i18n>Short code(s) in this lease can be renewed into Monthly Billing on the Payment tab of the
                Checkout process.</small></p>
    </div>
</div>
<div *ngIf="!renew && !bulk">
    <hr />
    <h3 i18n> Add Codes </h3>
    <div class="row col-12 ps-5">
        <p i18n>There are three ways to add a short code to your cart.</p>
    </div>
    <div class="row col-12 ps-5">
        <div class="col-4 vr-right">
            <div class="ms-3">
                <p i18n>Search for a Select Code</p>
                <div style="width: 95%;">
                    <p>
                        <small i18n>
                            Use the search box to type any combination of letters, numbers,
                            and up to 2 wild cards (*) to search for your 5- or 6-digit short code.
                        </small>
                    </p>
                </div>
                <div style="width: 95%;">
                    <form #shortCodeSearchForm="ngForm" name="shortCodeSearchForm" class="small-search-bar-form"
                        style="width: 90%;">
                        <input appShortCodeInput [shortCode]="selectCodeSearch" appShortCodeValidator type="text"
                            [disabled]="isPayLater()" class="small-search-bar-input" name="shortCodeSearch"
                            #shortCodeSearch="ngModel" id="shortCodeSearch" style="width: 100%;"
                            [(ngModel)]="selectCodeSearch" maxlength="{{MaxLen.ShortCode}}" minlength="5"
                            (input)="selectCodeOnChange()">
                        <button [disabled]="isPayLater()" *ngIf="!selectSearched" class="small-search-bar-button"
                            id="shortCodeSearchIcon" type="submit"
                            (click)="searchSelect(selectCodeSearch, shortCodeSearchForm)"><i
                                class="fas fa-magnifying-glass"></i></button>
                        <button [disabled]="isPayLater()" *ngIf="selectSearched" class="small-search-bar-button"
                            id="shortCodeClearSearchIcon" type="submit" (click)="clearSearchSelect(true, false)"><i
                                class="fas fa-xmark"></i></button>
                    </form>
                    <div *ngIf="selectCodeMessage">
                        <span id="selectCodeMessage" class="{{selectCodeMessageSeverity}}-text">{{selectCodeMessage}}</span>
                    </div>
                    <app-error-msg [field]="shortCodeSearch" fieldLabel="Short Code" [form]="shortCodeSearchForm">
                    </app-error-msg>
                </div>

                <button i18n *ngIf="codeAvailable && !(wildCardPaging.numberOfPages > 0)" class="btn btn-primary mt-3"
                    id="customAddToCartBtn" (click)="addSelect(selectCodeSearch)">Add to Cart</button>
            </div>
            <div class="mt-4">
                <span *ngIf="similarCodeOptions.length > 0"><b i18n>Similar options:</b></span>
                <app-multi-state-button *ngIf="similarCodeOptions.length > 0"
                    (optionClick)="multiButtonChange(shortCodeSearchForm)" [options]="similarCodeOptions"
                    (changed)="pendingOrderLeasesChanged($event)"
                    [maxSelections]="MAX_CART_CODES" [(ngModel)]="pendingOrder.leases" optionLabel="name"
                    optionValue="value" [multiple]=true dataKey="scId"></app-multi-state-button>
                <app-multi-state-button *ngIf="wildCardPaging.numberOfPages > 0"
                    (changed)="pendingOrderLeasesChanged($event)"
                    (optionClick)="multiButtonChange(shortCodeSearchForm)" [maxSelections]="MAX_CART_CODES"
                    [options]="wildCardPaging.pageContent[wildCardPaging.pageNumber]" [(ngModel)]="pendingOrder.leases"
                    optionLabel="name" optionValue="value" [multiple]=true dataKey="scId"></app-multi-state-button>
                <div *ngIf="wildCardPaging.numberOfPages > 1">
                    <button i18n class="btn btn-secondary" (click)="pageDown(wildCardPaging)" id="wildCardPageUp"
                        [disabled]="wildCardPaging.pageNumber === 0"><i class="fas fa-arrow-left"></i></button>
                    <button i18n class="btn btn-secondary ms-3" (click)="pageUp(wildCardPaging)" id="wildCardPageDown"
                        [disabled]="wildCardPaging.pageNumber === wildCardPaging.numberOfPages - 1"><i
                            class="fas fa-arrow-right"></i></button>
                </div>
            </div>
        </div>
        <div class="col-4 vr-right">
            <div class="ms-2">
                <p i18n>Find a Memorable Short Code</p>
                <div class="ms-2" style="width: 80%;">
                    <p-dropdown appDd (onChange)="memorableCodeChosen(memorableCodeChoice)" [options]="memorableOptions"
                        [(ngModel)]="memorableCodeChoice" scrollHeight="400" placeholder="Select an Option"
                        name="memorableCodeDD" id="memorableCodeDD" [disabled]="isPayLater()">
                    </p-dropdown>
                </div>
                <div class="mt-4">
                    <ul *ngIf="memorableCodeChoice === 'easyNumbers6' || memorableCodeChoice === 'easyNumbers5'"
                        class="ps-0">
                        <span>Display only those starting with:</span>
                        <br>
                        <button *ngFor="let easyNumber of easyNumbers; let i = index" class="btn"
                            [class.active]="selectedIndex === i"
                            (click)="startsWithFilter(easyNumber.name); setIndex(i);">
                            {{ easyNumber.name }}
                        </button>
                    </ul>
                    <ul *ngIf="memorableCodeChoice === 'coolNames'" class="ps-0">
                        <span>Display only those starting with:</span>
                        <br>
                        <button *ngFor="let coolNameFilter of coolNameFilters; let i = index" class="btn"
                            [class.active]="selectedIndex === i"
                            (click)="coolNameRangeFilter(coolNameFilter.name); setIndex(i);">
                            {{ coolNameFilter.name }}
                        </button>
                    </ul>
                    <form #memorableCodeRangeForm="ngForm" name="memorableCodeRangeForm"
                        (ngSubmit)="memorableCodeChosen('startsAfter')">
                        <div class="row" *ngIf="memorableCodeChoice === 'range'">
                            <div class="mb-3 col-5">
                                <label class="required" for="startRange">
                                    From
                                </label>
                                <input required appScrText appShortCodeValidator #fromRange="ngModel" name="fromRange"
                                    style="width: 100%;" [(ngModel)]="shortCodeRange.fromRange" id="fromRange"
                                    maxlength="{{MaxLen.ShortCode}}" minlength="5" appShortCodeInput
                                    [shortCode]="shortCodeRange.fromRange" appGreaterComparisonValidator
                                    [comparisonField]="toRange"
                                    onkeypress='return event.charCode >= 48 && event.charCode <= 57'>
                            </div>
                            <div class="col-5 mb-3">
                                <label class="required" for="endRange">To
                                </label>
                                <input appScrText appShortCodeValidator #toRange="ngModel" name="toRange" style="width: 100%;"
                                    [(ngModel)]="shortCodeRange.toRange" id="toRange" maxlength="{{MaxLen.ShortCode}}"
                                    minlength="5" appShortCodeInput [shortCode]="shortCodeRange.toRange" required
                                    appLessComparisonValidator [comparisonField]="fromRange"
                                    onkeypress='return event.charCode >= 48 && event.charCode <= 57'>
                            </div>
                            <div class="px-2">
                                <app-error-msg [field]="toRange" [fieldTwo]="fromRange" fieldLabel="Short Code"
                                    [form]="memorableCodeRangeForm"></app-error-msg>
                            </div>
                        </div>
                        <button *ngIf="memorableCodeChoice === 'range'" class="btn btn-primary mt-2"
                            type="submit">Search</button>
                    </form>
                    <div *ngIf="memorableCodeMessage">
                        <span id="memorableCodeMessage" class="error-text">{{memorableCodeMessage}}</span>
                    </div>
                    <app-multi-state-button *ngIf="memorableCodePaging.numberOfPages > 0"
                        (optionClick)="multiButtonChange(memorableCodeRangeForm)"
                        (changed)="pendingOrderLeasesChanged($event)"
                        [options]="memorableCodePaging.pageContent[memorableCodePaging.pageNumber]"
                        [maxSelections]="MAX_CART_CODES" [(ngModel)]="pendingOrder.leases" optionLabel="name"
                        additionalOptionLabel="additionalName" optionValue="value" [multiple]=true dataKey="scId">
                    </app-multi-state-button>
                    <div *ngIf="memorableCodePaging.numberOfPages > 1">
                        <button i18n class="btn btn-secondary" (click)="pageDown(memorableCodePaging)"
                            id="memorableCodePageUp" [disabled]="memorableCodePaging.pageNumber === 0"><i
                                class="fas fa-arrow-left"></i></button>
                        <button i18n class="btn btn-secondary ms-3" (click)="pageUp(memorableCodePaging)"
                            id="memorableCodePageDown"
                            [disabled]="memorableCodePaging.pageNumber === memorableCodePaging.numberOfPages - 1"><i
                                class="fas fa-arrow-right"></i></button>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-4">
            <div>
                <p i18n>Generate a Random Short Code</p>
                <div>
                    <p><small i18n>I need &nbsp;<p-inputNumber appIn [disabled]="isPayLater()" #randomCodeCount
                                [showButtons]="true" id="randomCodeCount" [min]="1" [size]="2"
                                [max]="MAX_CART_CODES - pendingOrder.leases.length === 0? 1: MAX_CART_CODES - pendingOrder.leases.length"
                                [(ngModel)]="randomCodesToGen">
                            </p-inputNumber>&nbsp; random short code(s).</small></p>
                </div>
                <div *ngIf="randomCodeMessage">
                    <span id="randomCodeMessage" class="error-text">{{randomCodeMessage}}</span>
                </div>
                <button [disabled]="isPayLater()" i18n class="btn btn-primary mt-2" id="randomAddToCartBtn"
                    (click)="addRandom(randomCodesToGen)">Add to Cart</button>
            </div>
        </div>
    </div>
</div>
<ng-template [appAuthIf]="[CognitoGroup.Registrant]">
    <hr />
    <h3 i18n> Promotions </h3>
    <div class="col-3">
        <label i18n for="promoCode" style="display:block;" i18n>Promotion Code</label>
        <div class="input-group">
            <input [disabled]="isPayLater()" appUppercase name="promoCode" [(ngModel)]="promoCode" id="promoCode" text
                class="form-control d-block col-2 me-3 mt-0" maxlength="32">
            <button [disabled]="isPayLater()" i18n class="borderRadiusRestored btn btn-primary" (click)="redeemPromo()"
                id="redeemPromoBtn">Redeem</button>
        </div>
    </div>
    <small i18n>Only one per order.</small>
    <hr />
    <ng-template [ngIf]="hasRedeemedDiscounts(pendingOrder)">
        <h3> Redeemed Promotion Code </h3>
        <div class="col-6" style="padding: 0;">
            <table class="table table-light">
                <tbody>
                    <tr *ngFor="let disc of getRedeemedDiscounts(pendingOrder)">
                        <td>{{disc.redeemCode}}</td>
                        <td>{{disc.displayName}}</td>
                        <td style="width: 4rem;">
                            <a *ngIf="!isPayLater()" class="ms-2" style="cursor: pointer;" (click)="removePromo(disc)">
                                <i class="far fa-trash-can fa-xl icon-teal"></i>
                            </a>
                            <a *ngIf="isPayLater()" class="ms-2" style="cursor: pointer;">
                                <i class="far fa-trash-can fa-xl icon-disabled"></i>
                            </a>
                    </tr>
                </tbody>
            </table>
        </div>
    </ng-template>
</ng-template>
<div class="footer">
    <div class="d-flex justify-content-end">
        <button i18n class="btn btn-primary me-3" (click)="next()" id="nextBtn">
            Next
        </button>
        <div *ngIf="!renew && !bulk">
            <button i18n class="btn btn-secondary" (click)="cancelOrder()" id="canOrder">
                {{ isPayLater() ? "Cancel" : "Clear Order" }}
            </button>
        </div>
        <div *ngIf="renew || bulk">
            <button i18n class="btn btn-secondary" (click)="cancelOrder()" id="canOrder">
                Cancel Renew
            </button>
        </div>
    </div>
</div>

<p-confirmDialog key='canOrder' #canOrder width="425" [closable]="false">
    <p-footer>
        <button i18n id="canAccept" class="btn btn-primary me-2" (click)="canOrder.accept()">Yes</button>
        <button i18n id="canReject" class="btn btn-secondary" (click)="canOrder.reject()">No</button>
    </p-footer>
</p-confirmDialog>